export enum EnApi {
  CMS_API_TAG = '@cms',
  SALESKIT_API_TAG = '@saleskit',
  CDN = 'https://cdn.noda.live',
  STORE_HOST = 'https://nodastore.azureedge.net',
  BLOB_HOST = 'https://noda.blob.core.windows.net/storage',

  MARKETPLACE_API_TAG = '@marketplace',
  LANDING_API_TAG = '@landing',
}
